import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const totalGEXGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX_Total_GEX',
      metainfo: {
        metainfoVersion: 53,
        id: "SPX_Total_GEX@tv-basicstudies-1",
        description: "SPX Total GEX",
        shortDescription: "SPX Total GEX",
        linkedToSeries: true,
        is_price_study: false,
        format: { type: "price" },

        // net_gex + zero_line + shading channels (unchanged)
        plots: [
          { id: "net_gex",  type: "line", title: "Net GEX",  trackPrice: true,  transparency: 70, fillGaps: true },
          { id: "zero_line",type: "line", title: "Zero Line" },
          { id: "gex_pos",  type: "line", title: "Positive Area", trackPrice: false, fillGaps: true },
          { id: "gex_neg",  type: "line", title: "Negative Area", trackPrice: false, fillGaps: true },
        ],

        defaults: {
          styles: {
            // Outline (keeps the one visible last-value label)
            net_gex: {
              linestyle: 0, linewidth: 1, plottype: 0,
              trackPrice: false, transparency: 0, visible: false,
              color: "#9bb1ff", joinPoints: true
            },

            zero_line: {
              linestyle: 0, linewidth: 1, color: "#ffffff", visible: false
            },

            // Shaded areas
            gex_pos: {
              linestyle: 0, linewidth: 2, plottype: 8, areaStyle: 1,
              trackPrice: false, transparency: 70, visible: true, color: "#04756F"
            },
            gex_neg: {
              linestyle: 0, linewidth: 2, plottype: 8, areaStyle: 1,
              trackPrice: false, transparency: 70, visible: true, color: "#d90000"
            },
          },
          precision: 2,
          inputs: {}
        },

        // HIDE labels for shading & zero-line; keep net_gex visible
        styles: {
          net_gex:  { title: "Net GEX (line)", joinPoints: true },

          zero_line:{ title: "Zero Line", showAxisLabel: false, showLegendValues: false, showLastValue: false },

          gex_pos:  { title: "GEX (+)", histogramBase: 0, areaStyle: 1, joinPoints: true,
                      showAxisLabel: false, showLegendValues: false, showLastValue: false },

          gex_neg:  { title: "GEX (−)", histogramBase: 0, areaStyle: 1, joinPoints: true,
                      showAxisLabel: false, showLegendValues: false, showLastValue: false },
        },

        inputs: []
      },

      constructor: function () {
        this._debugMode = true;
        this._lastSign = 0;

        this.init = function (ctx) { this._context = ctx; };

        this.main = function (ctx) {
          try {
            const { greekExposures } = useGreeksWebsocketDataStore.getState();
            const spxExposures = greekExposures.spx;
            if (!spxExposures?.length) return [NaN, 0, 0, 0];

            const chartTime = Number(ctx.symbol.time);
            if (!Number.isFinite(chartTime)) return [NaN, 0, 0, 0];
            const chartTimeMs = chartTime < 10_000_000_000 ? chartTime * 1000 : chartTime;
            const exposureTimeMs = (exposure) => {
              const timestamp = Number(exposure.timestamp);
              return timestamp < 10_000_000_000 ? timestamp * 1000 : timestamp;
            };

            const gamma = spxExposures
              .filter(e => e.greek_type === 'gamma' && Number.isFinite(exposureTimeMs(e)));
            if (!gamma.length) return [NaN, 0, 0, 0];

            // nearest point
            let best = gamma[0], md = Math.abs(exposureTimeMs(best) - chartTimeMs);
            for (const e of gamma) {
              const d = Math.abs(exposureTimeMs(e) - chartTimeMs);
              if (d < md) { md = d; best = e; }
            }

            const vRaw = parseFloat(best.net_exposure);
            const value = Number.isFinite(vRaw) ? vRaw : 0;

            // sign-latch + EPS film (same as your Market GEX module)
            const EPS = 1e-6, ZERO_BAND = 1e-9;
            let sign = (value > ZERO_BAND) ? 1 : (value < -ZERO_BAND) ? -1 : (this._lastSign || 0);
            if (Math.abs(value) > ZERO_BAND) this._lastSign = sign;

            let pos = 0, neg = 0;
            if (sign >= 0) { pos = (value > 0 ? value : EPS); neg = 0; }
            else           { pos = 0;                         neg = (value < 0 ? value : -EPS); }

            // plots order: [net_gex(line), zero_line, gex_pos(area), gex_neg(area)]
            return [value, 0, pos, neg];

          } catch (err) {
            console.error('[totalGEXGetter] Error in main:', err);
            return [NaN, 0, 0, 0];
          }
        };
      }
    }
  ]);
};








// import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';
//
// export const totalGEXGetter = function (PineJS) {
//  return Promise.resolve([
//    {
//      name: 'SPX_Total_GEX',
//      metainfo: {
//        metainfoVersion: 53,
//        id: "SPX_Total_GEX@tv-basicstudies-1",
//        description: "SPX Total GEX",
//        shortDescription: "SPX Total GEX",
//        linkedToSeries: true,
//        is_price_study: false,
//        format: { type: "price" },
//        plots: [
//          {
//            id: "net_gex",
//            type: "line",
//            title: "Net GEX",
//            trackPrice: true,
//            transparency: 70,
//            fillGaps: true
//          },
//          {
//            id: "zero_line",
//            type: "line",
//            title: "Zero Line"
//          }
//        ],
//        defaults: {
//          styles: {
//            net_gex: {
//              linestyle: 0,
//              linewidth: 1,
//              plottype: 8,
//              trackPrice: false,
//              transparency: 60,
//              visible: true,
//              color: "#73a9e7",
//              color2: "#FF4500",
//            },
//            zero_line: {
//              linestyle: 0,
//              linewidth: 1,
//              color: "#ffffff",
//              visible: true
//            }
//          },
//          precision: 2,
//          inputs: {}
//        },
//        styles: {
//          net_gex: { title: "Net GEX", histogramBase: 0 },
//          zero_line: { title: "Zero Line" }
//        },
//        inputs: []
//      },
//      constructor: function () {
//        this._debugMode = true;
//
//        this.init = function (ctx) {
//          this._context = ctx;
//        };
//
//        this.main = function (ctx) {
//          try {
//            const { greekExposures } = useGreeksWebsocketDataStore.getState();
//            const spxExposures = greekExposures.spx;
//
//            if (!spxExposures?.length) {
//              if (this._debugMode) {
//                // console.log('[totalGEXGetter] No greek exposures data');
//              }
//              return [null, null];
//            }
//
//            const time = ctx.symbol.time;
//            if (!time || isNaN(time)) {
//              if (this._debugMode) {
//                // console.log('[totalGEXGetter] Invalid symbol time:', time);
//              }
//              return [null, null];
//            }
//
//            const timeInSec = Math.floor(time / 1000);
//
//            const gammaExposures = spxExposures
//              .filter(exp => exp.greek_type === 'gamma')
//              .sort((a, b) => a.timestamp - b.timestamp);
//
//            if (!gammaExposures.length) {
//              return [null, null];
//            }
//
//            // Find the closest data point to the requested time
//            let closestExp = gammaExposures[0];
//            let minDiff = Math.abs(closestExp.timestamp - timeInSec);
//
//            for (const exp of gammaExposures) {
//              const diff = Math.abs(exp.timestamp - timeInSec);
//
//              if (diff < minDiff) {
//                minDiff = diff;
//                closestExp = exp;
//              }
//            }
//
//            const value = parseFloat(closestExp.net_exposure) || 0;
//
//            return [value, 0];
//          } catch (err) {
//            console.error('[totalGEXGetter] Error in main:', err);
//            return [null, null];
//          }
//        };
//
//        this.destroy = function() {
//          // No cleanup needed since we're not using subscriptions
//        };
//      }
//    }
//  ]);
// };



